import { render, staticRenderFns } from "./ReportGameProvider.vue?vue&type=template&id=7e781a7e"
import script from "./ReportGameProvider.vue?vue&type=script&lang=js"
export * from "./ReportGameProvider.vue?vue&type=script&lang=js"
import style0 from "./ReportGameProvider.vue?vue&type=style&index=0&id=7e781a7e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports